module.exports = __webpack_public_path__ + "static/media/ico_close_o.316a0465.svg";